<template>
  <div class="container-fluid pb-1 sub-nav">
    <div class="row mx-3 my-4">
      <div class="col-md-12">
        <slot name="title" :title="title">
          <h4 class="h4 text-muted font-weight-bold">
            {{ title }}
          </h4>
          <span>{{ description }}</span>
          <router-link v-if="link" :to="link.href" :class="['btn btn-link', link.class]">
            <strong>{{ link.text }}</strong>
          </router-link>
        </slot>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "SubNav",
  props: {
    /**
     *
     */
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    link: {
      type: Object,
      default: null,
    },
  },
};
</script>
<style lang="scss" scoped></style>
